<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2.vue'
import ProductType from '@/router/views/setting/product/ProductType.vue'
import ProductCategory from '@/router/views/setting/product/ProductCategory.vue'
import UnitMeasure from '@/router/views/setting/product/UnitMeasure.vue'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ProductType,
    ProductCategory,
    UnitMeasure,
  },
  data() {
    return {
      tabIndex: 0,
      tabs: ['#product-category', '#product-type', '#unit-of-measurements'],
    }
  },
  computed: {
    title() {
      return this.$t('setting.homePage.product')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.list.productSetting.setting'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.productSetting.product'),
        },
      ]
    },
  },
  beforeMount() {
    // Match router hash to current active tab
    const idx = this.tabs.findIndex((tab) => tab === this.$route.hash)
    if (idx !== -1) this.tabIndex = idx
  },
  methods: {
    handleActivateTab(newTabIndex) {
      this.$router.push(this.tabs[newTabIndex])
      const filters = {
        page: 1,
        limit: 10,
      }
      switch (newTabIndex) {
        case 0:
          this.$refs.productCategory?.apiClient.get(filters)
          break
        case 1:
          this.$refs.productType?.apiClient.get(filters)
          break
        case 2:
          this.$refs.unitMeasure?.apiClient.get(filters)
          break
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="$t('setting.homePage.textProduct')"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <b-card class="mc-card__setting">
      <b-tabs v-model="tabIndex" content-class="p-3 text-muted" @input="handleActivateTab">
        <ProductCategory ref="productCategory" />
        <ProductType ref="productType" />
        <UnitMeasure ref="unitMeasure" />
      </b-tabs>
    </b-card>
  </Layout>
</template>

<style lang="scss" scoped>
::v-deep .multiselect.multiselect--active.multiselect--above .multiselect__tags {
  padding: 0 !important;
}

::v-deep .multiselect.multiselect--above .multiselect__tags {
  padding: 0px 10px !important;
  max-height: none;

  > .custom__tag {
    padding: 5.5px 10px 5.5px 3px !important;
    max-height: none;

    .__tag {
      height: 18px;
      border-radius: 15px;
    }
  }

  .__count {
    height: 18px;
    font-size: 12px !important;

    i::before {
      font-size: 12px !important;
    }

    span {
      font-size: 12px !important;
    }
  }
}
</style>